import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { DefaultDataGrid } from '@cbridge-tools/default-data-grid';
import { IEmailRecipient } from './AlertEmailRecipients.interface';
import { useEmailRecipientsGridColDef } from '../../_hooks/useEmailRecipientsGridColDef';
import { alertEmailRecipientsDataGridPropsSelector } from './AlertEmailRecipientsDataGrid.selector';

const getRowIdFn = (row: IEmailRecipient) => row.email;

export const AlertEmailRecipientsDataGrid: FunctionComponent = () => {
  const { recipients, alertTypes, isLoading } = useSelector(alertEmailRecipientsDataGridPropsSelector);

  const columns = useEmailRecipientsGridColDef({ alertTypes });

  return (
    <DefaultDataGrid
      disableRowSelectionOnClick={true}
      getRowId={getRowIdFn}
      rows={recipients}
      columns={columns}
      loading={isLoading}
      initialState={{ sorting: { sortModel: [{ field: 'email', sort: 'asc' }] } }}
      slotProps={{
        root: { 'data-testid': 'alert-email-recipients-data-grid' },
      }}
    />
  );
};
